import { Icon } from '@chakra-ui/react';

export const HeadphonesSupport = (props) => (
  <Icon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 11.9999C3.00014 13.0542 3.18764 14.0999 3.55376 15.0885C3.63489 15.311 3.7916 15.4979 3.9965 15.6166C4.20141 15.7353 4.44151 15.7783 4.67486 15.738L5.66105 15.5641C6.04448 15.4965 6.38661 15.2824 6.6151 14.9672C6.8436 14.6519 6.94056 14.2602 6.8855 13.8747L6.58868 11.797C6.56024 11.5979 6.49205 11.4066 6.38818 11.2344C6.28431 11.0622 6.14688 10.9126 5.98405 10.7946C5.82122 10.6766 5.63633 10.5925 5.44035 10.5474C5.24438 10.5023 5.04134 10.497 4.84329 10.5319L3.0827 10.8424"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9999 11.9999C20.9998 13.0542 20.8123 14.0999 20.4462 15.0885C20.3651 15.311 20.2084 15.4979 20.0034 15.6166C19.7985 15.7353 19.5584 15.7783 19.3251 15.738L18.3389 15.5641C17.9555 15.4965 17.6133 15.2824 17.3848 14.9672C17.1563 14.6519 17.0594 14.2602 17.1144 13.8747L17.4113 11.797C17.4397 11.5979 17.5079 11.4066 17.6118 11.2344C17.7156 11.0622 17.8531 10.9126 18.0159 10.7946C18.1787 10.6766 18.3636 10.5925 18.5596 10.5474C18.7556 10.5023 18.9586 10.497 19.1567 10.5319L20.9172 10.8424"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
